import ReactGA from "react-ga4";
import Env from "../../Environments";

export const triggerGAEvent = (name, params) => {
  if (name && Env.getGoogleAnalyticsEnabled()) {
    ReactGA.event(name, params);
  }
};
